import { RefObject, useRef } from 'react';
import { FadeTransition } from 'src/animations/FadeTransition';
import classNames from 'classnames';
import styles from './ScrollToEdgeButton.module.scss';
import { ArrowUp, ArrowDown } from '@phosphor-icons/react';
import { SVG_SIZE_M } from 'src/constants';
import { Button } from 'src/v2/commonComponents/Button';
import { useScrollToTopConversations } from 'src/hooks';

interface ScrollToEdgeButtonProps {
  scrollableContainerRef: RefObject<HTMLElement> | null;
  direction: 'up' | 'down';
  isVisible: boolean;
  className?: string;
  onClick?: () => void;
}

export const ScrollToEdgeButton = ({
  scrollableContainerRef,
  direction,
  className,
  isVisible,
  onClick,
}: ScrollToEdgeButtonProps) => {
  const buttonRef = useRef<HTMLButtonElement | null>(null);

  const { handleScroll } = useScrollToTopConversations();

  const handleScrollToTopClick = () => {
    handleScroll({
      direction,
      scrollableContainerRef,
      onClick,
    });
  };

  return (
    <FadeTransition inProp={isVisible} nodeRef={buttonRef} unmountOnExit>
      <Button
        ref={buttonRef}
        className={classNames(styles.button, className)}
        onClick={handleScrollToTopClick}
        shape="round"
        color="transparent"
      >
        {direction === 'up' ? (
          <ArrowUp size={SVG_SIZE_M} />
        ) : (
          <ArrowDown size={SVG_SIZE_M} />
        )}
      </Button>
    </FadeTransition>
  );
};
